import { render, staticRenderFns } from "./save-user-dialog.component.vue?vue&type=template&id=556f16c4"
import script from "./save-user-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./save-user-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('556f16c4')) {
      api.createRecord('556f16c4', component.options)
    } else {
      api.reload('556f16c4', component.options)
    }
    module.hot.accept("./save-user-dialog.component.vue?vue&type=template&id=556f16c4", function () {
      api.rerender('556f16c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user-setup/save-user-dialog/save-user-dialog.component.vue"
export default component.exports